import { Directive, HostListener } from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

@Directive({
  selector: '[phoneValidatorMask]'
})
export class PhoneValidatorMaskDirective {

  constructor(public ngControl: NgControl) { }

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    // Remove all non-digit characters
    let numericValue = value.replace(/\D/g, '').slice(0, 10);
    // console.log('numericValue: ', numericValue);

    // Apply formatting based on the length
    numericValue = numericValue.replace(/(\d{3})(\d{1,3})?(\d{1,4})?/, (match, g1, g2, g3) => {
      return `${g1}${g2 ? '-' + g2 : ''}${g3 ? '-' + g3 : ''}`;
    });

    // Update the input value with the formatted value
    this.ngControl.control.setValue(numericValue);

    // Adjust the validation
    this.adjustValidation(numericValue);
  }

  adjustValidation(value: string) {
    // Regular expression to match the phone number with optional extension
    let regex = /^(?:\d{3}-){2}\d{4}?$/;
    let isValid = regex.test(value);

    // Apply validation conditionally based on the match result
    this.ngControl.control.setValidators(isValid ? null : Validators.pattern(regex));
    this.ngControl.control.updateValueAndValidity();
  }
}